<template>
  <div>
    <label>Condição de pagamento</label>

    <div class="w3-row">
      <div class="w3-col s4 l2">
        <input
          type="text"
          @keyup.enter="inserirDadoPorChave()"
          ref="condicao_pagamento"
          class="w3-input w3-border input-codigo"
          v-model="chave_pesquisa"
          :disabled="somenteLeitura == 'S'"
          v-bind:placeholder="placeholder_codigo"
          @blur.stop="onBlurChave()"
          maxlength="15"/>
      </div>

      <div class="w3-col s8 l10">
        <div class="input-container">
          <input
            class="input-registro-selecionado w3-border"
            type="text"
            v-model="condicao_selecionada.nome"
            @click="abrirPesquisa"
            :disabled="somenteLeitura == 'S'"
            placeholder="Clique para selecionar a condição de pagamento"
            readonly/>

          <i
            v-if="somenteLeitura == 'N'"
            class="fas fa-minus icone w3-border-top w3-border-right w3-border-bottom"
            @click="limparDados"/>
        </div>
      </div>
    </div>

    <pesquisa-condicoes-pagamento
      ref="pesquisaCondicoesPagamento"
      @confirmar="carregar">
    </pesquisa-condicoes-pagamento>

  </div>
</template>

<script>
  import RCondicao from '@/components/Rest/RCondicao'
  import Biblioteca from '@/components/Repositorio/Biblioteca'
  import PesquisaCondicoesPagamento from '@/components/Pesquisas/PesquisaCondicoesPagamento'

  export default {
    name: 'FrameCondicaoPagamento',

    components: {
      PesquisaCondicoesPagamento
    },

    props: {
      liberadaClienteSimplificado: {
        required: true,
        type: String,
        default: 'N'
      },

      somenteEmpresasLiberadas: {
        required: true,
        type: String,
        default: 'N'
      },

      somenteLeitura: {
        required: true,
        type: String,
        default: 'N'
      },

      /*
        Caso necessite preencher o vendedor no create, informar nesta property
        Caso que isso acontece:
          - Caso o frame esteja em um v-if (que recria o elemento a medida que a condição muda).
          Exemplo: Clientes simplificados.
      */
      condicaoSelecionada: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      },

      verificarDados: {
        required: false,
        type: Function,
        default: function (condicao) {
          return true;
        }
      }
    },

    data() {
      return {
        condicao_selecionada: {},
        chave_pesquisa: '',
        placeholder_codigo: 'Cód.'
      }
    },
  
    methods: {
      async inserirDadoPorChave(chave) {

        if (this.valorInt(chave) > 0){
          this.chave_pesquisa = chave;
        }

        let condicao_id = this.valorInt(this.chave_pesquisa);

        if 
          (
            (this.chave_pesquisa == '') ||
            (condicao_id <= 0)
          )
        {
          Biblioteca.exclamar('Digite um código válido!');
          return;
        }  

        try {
          let parametros = {
            chave: condicao_id,
            liberada_cliente_simplificado: this.liberadaClienteSimplificado,
            somente_empresas_liberadas: this.somenteEmpresasLiberadas
          }

          let retorno = await RCondicao.buscarCondicaoPagamentoCompleta(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          if (await this.verificarDados(retorno.dados)) {
            this.carregar(JSON.parse(JSON.stringify(retorno.dados)));
          }
        }
        catch (e) {
          this.limparDados();
          Biblioteca.exclamar(e.message);
        }
      },

      abrirPesquisa() {
        this.$refs.pesquisaCondicoesPagamento.abrir(
          this.liberadaClienteSimplificado, 
          this.somenteEmpresasLiberadas
        );
      },

      /* Aplica as modificações visuais do frame quando um cliente é selecionado */
      carregar(condicao, carregando_offline) {
        this.chave_pesquisa = '';

        if ((!condicao) || (!condicao.condicao_id)) {
          this.limparDadosComponente();
          return;
        }

        this.condicao_selecionada = JSON.parse(JSON.stringify(condicao));
        this.placeholder_codigo = Biblioteca.nPadrao(
          this.condicao_selecionada.condicao_id,
          0
        );

        if (!carregando_offline){
          this.$emit('confirmar', this.condicao_selecionada);
        }
      },

    onBlurChave() {
      if (this.chave_pesquisa) {
        if (this.condicao_selecionada.condicao_id) {
          if (this.condicao_selecionada.condicao_id != this.valorInt(this.chave_pesquisa)) {
            this.inserirDadoPorChave(this.chave_pesquisa);
          }
        }
        else {
          this.inserirDadoPorChave(this.chave_pesquisa);
        }
      }
    },

      limparDadosComponente(){
        this.chave_pesquisa = '';
        this.placeholder_codigo = 'Cód.';
        this.condicao_selecionada = {};
      },

      limparDados() {
        this.limparDadosComponente();
        this.$emit('limparDados');
      },

      valor(numero_str) {
        return Biblioteca.valor(numero_str);
      },

      valorInt(numero) {
        return Biblioteca.valorInt(numero);
      }
    },

    created() {
      if (this.condicaoSelecionada) {
        this.carregar(this.condicaoSelecionada);
      }
    }
  }
</script>

<style escoped>
  .card-item {
    background-color: #f3f3f3;
    border-radius: 10px;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
    margin-bottom: 5px;
    padding: 3px !important;
  }

  .input-codigo {
    padding: 10px 15px;
    border-radius: 0px;
    position: relative;
    z-index: 0;
    font-weight: bold;
  }

  .input-container {
    display: -ms-flexbox; 
    display: flex;
    position: relative;
    z-index: 1;
    margin-left: -20px;
    width: calc(100% + 20px);
  }

  .icone {
    padding: 11px;
    background: gray;
    color: white;
    min-width: 15px;
    text-align: center;
    border-left-style: none;
  }

  .icone:active {
    background-color: #ccc;
    box-shadow: 0 1px #666;
    transform: translateY(1px);
  }

  .input-registro-selecionado {
    width: 100%;
    padding: 10px;
    outline: none;
    cursor: pointer;
    font-weight: bold;
    border-right-style: none;
  }

</style>


// WEBPACK FOOTER //
// src/components/Frames/FrameCondicaoPagamento.vue